import React from 'react';
import cx from 'classnames';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import { Expandable } from 'Storybook/components/local/Expandable/Expandable';

import { usePageRefEvents } from '../Hooks/usePageRefEvents';

import styles from './FAQSection.scss';

type FAQPropType = {
  answer: string;
  question: string;
}[];

type FAQSectionProps = {
  className?: Record<string, string> | string | null;
  faq: FAQPropType;
  onLoad?: () => void;
  title: React.ReactNode;
};

export const createFAQData = (acf: {
  [key: string]: string | undefined;
}) => {
  const questionKey = 'faq_question';

  if (!acf) {
    return [];
  }

  return Object.entries(acf).reduce((acc: FAQPropType, [name, val]) => {
    if (name.includes(questionKey) && val) {
      const keys = name.split(questionKey);
      const answer = acf[`faq_answer${keys[1]}`];
      if (answer) {
        acc.push({
          answer,
          question: val,
        });
      }
    }
    return acc;
  }, []);
};

const FAQSection = ({ className, faq, onLoad, title }: FAQSectionProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <div
      ref={(ref) => setRef(ref)}
      className={cx(styles.component, className)}
      data-testid="faqSection"
      role="presentation"
    >
      <h2>{title}</h2>
      <ComponentContent maxWidth={CONTENT_SIZES.large}>
        <div className={styles.faqWrapper}>
          {
            faq.map(({ answer, question }, index) => (
              <Expandable
                key={`faq-item-${index + 1}`}
                caption={question}
                id={`faq-item-${index + 1}`}
              >
                <div dangerouslySetInnerHTML={{ __html: answer }} />
              </Expandable>
            ))
          }
        </div>
      </ComponentContent>
    </div>
  );
};

export default FAQSection;
